import {
    validityOptions,
    STATUS_TYPE
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function PaymentPageList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

PaymentPageList.prototype = Object.assign(PaymentPageList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.linkDataList &&
            tableData.linkDataList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements, pageNo } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: pageNo || 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            amount,
            createdBy,
            createdDate,
            numberOfTransactions,
            maxAmount,
            linkId,
            sumTxns,
            entityName,
            status,
            validityPeriod,
            successCount,
            numTxns,
            linkUrl,
            validTill,
            dataId,
            template,
            minAmount,
            amountType
        } = row;
        return {
            minAmount,
            amountType,
            amount,
            createdBy,
            pageId: dataId,
            sumTxns,
            createdOn: this.convertDateTime(createdDate),
            numberOfTransactions,
            maxAmount,
            entityName,
            status,
            validityPeriod,
            successCount,
            numTxns,
            linkUrl,
            validTill: validTill ? this.convertDateTime(validTill) : '-',
            linkId,
            template,
        };
    },
    getTransactionStatus(status) {
        if (!status) {
            return '-';
        }
        return STATUS_TYPE[status];
    },
    getValidity(validityPeriod) {
        if (!validityPeriod) {
            return '-';
        }
        const values = validityOptions.filter(
            item => item.value === validityPeriod
        );
        return (values && values.length && values[0].name) || '-';
    },
    convertDate(date) {
        const dateString = moment(parseInt(date)).format('DD/MM/YYYY');
        return dateString;
    },
    convertDateTime(date) {
        
        if (!date) return "N/A";
    
        let timestamp = parseInt(date);
        if (timestamp.toString().length === 10) {
            timestamp *= 1000; // Convert seconds to milliseconds
        }
    
        return new Date(timestamp).toLocaleString("en-IN", { 
            timeZone: "UTC", 
            day: "2-digit", 
            month: "2-digit", 
            year: "numeric", 
            hour: "2-digit", 
            minute: "2-digit", 
            hourCycle: "h23"  // Ensures 24-hour format
        });
    }
    
});

export default PaymentPageList;
